// What a multi-file add reports: how many landed, and each refusal with its reason. Pure.
import type { Refused } from './types';

/** One file of an add, and the folder it lands in ('' or absent: the root). */
export interface BatchItem {
  file: File;
  folder?: string;
}

/** A finished add: how many files it was given, and the ones it did not take, in order. */
export interface BatchResult {
  total: number;
  refused: Refused[];
}

/**
 * The drawer's one line for an add, or null when everything landed. One
 * file alone keeps its own sentence; a batch says how many of how many,
 * then each refused name with its reason.
 */
export function batchSummary({ total, refused }: BatchResult): string | null {
  if (refused.length === 0) return null;
  if (total === 1) return refused[0].sentence;
  const list = refused.map((r) => `${r.name} (${r.reason})`).join('; ');
  return `Added ${total - refused.length} of ${total}. Not added: ${list}.`;
}
